let _API_URL = '';

_API_URL = process.env.REACT_APP_API_URL as string;

const API_URL = _API_URL;

export { API_URL };
